@if (!showSpinner) {
  <button class="period-list__my-lessons-button"
    role="button"
    (click)="goToMyAssignments()">
    <span class="period-list__my-lessons-label">{{ 'generic.my_lessons' | translate }}</span>
    <div class="period-list__my-lessons-count">
      <span>{{ assignmentCount }}</span>
    </div>
  </button>
  <div class="period-list__wrapper">
    @for (c of chapters; track c; let index = $index) {
      <button
        class="period-list__period-button"
        [ngClass]="index % 2 == 0 ? 'period-list__period-button--even' : 'period-list__period-button--odd'"
        (click)="navigateToLesson(c)">
        <div class="period-list__period-header">
          <div class="period-list__period-index">
            <span>{{ index + 1 }}</span>
          </div>
          <div class="period-list__period-state"
            [ngClass]="'period-list__period-state--' + c.state">
            @if (getIcon(status[c.state])) {
              <mat-icon
                [svgIcon]="getIcon(status[c.state])">
              </mat-icon>
            }
            <span>{{ ('generic.period_' + c.state) | translate }}</span>
          </div>
          @if (c.state != undefined) {
            <app-progress-bar-generic
              class="period-list__period-progress-bar"
              [ngClass]="c.progress === 100 ? 'period-list__period-progress-bar--filled' : null"
              [pourcent]="c.progress">
            </app-progress-bar-generic>
          }
        </div>
        <div class="period-list__period-label">{{ c.label }}</div>
      </button>
    }
  </div>
} @else {
  <mat-spinner class="period-list__spinner"></mat-spinner>
}


@if (shouldShowLaunchButton) {
  <app-launch-button class="period-list__launch-button"></app-launch-button>
}